document.addEventListener('DOMContentLoaded', function () {
  const overlay = document.querySelector('.search-drawer-mobile-overlay');
  const drawer = document.querySelector('.search-drawer-mobile');
  const wrapper = document.querySelector('.search-drawer-wrapper');
  const queriesContainer = document.querySelector('.main-queries-container');
  const placeholder = drawer.querySelector('.mobile-placholderimag_load');
  const searchInput = drawer.querySelector('.search-input');
  const resultsContainer = drawer.querySelector('.search-result-list-wrapper');
  const body = document.body;

  if (!drawer || !searchInput || !resultsContainer) return;

  // 🔹 SVG placeholder
  const svgPlaceholder = `
    <svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <rect width="100" height="100" fill="#eee"/>
      <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#aaa" font-size="12">No Image</text>
    </svg>
  `;

  // 🔹 Show suggestions
  const showSuggestions = () => {
    queriesContainer.classList.add('active');
    resultsContainer.style.display = 'none';
    resultsContainer.innerHTML = '';
    placeholder?.style.setProperty('display', 'none');
  };

  // 🔹 Show results
  const showResults = (html) => {
    queriesContainer.classList.remove('active');
    resultsContainer.innerHTML = html || '<div class="no-results paragraph-medium">No results found</div>';
    resultsContainer.style.display = 'flex';
    placeholder?.style.setProperty('display', 'none');
  };

  // 🔹 Open drawer
  document.querySelectorAll('.search-icon-mobile').forEach(icon => {
    icon.addEventListener('click', () => {
      overlay.classList.add('overlay-active');
      drawer.classList.add('search-drawer-mobile-active');
      wrapper.classList.add('open-wrapper');
      body.classList.add('overflow-hidden');
      showSuggestions();
      setTimeout(() => searchInput.focus(), 0);
    });
  });

  // 🔹 Close drawer
  const closeDrawer = () => {
    overlay.classList.remove('overlay-active');
    drawer.classList.remove('search-drawer-mobile-active');
    wrapper.classList.remove('open-wrapper');
    body.classList.remove('overflow-hidden');
    showSuggestions();
  };
  overlay?.addEventListener('click', closeDrawer);
  drawer.querySelector('.mobile-search-drawer-close-icon')?.addEventListener('click', closeDrawer);

  // 🔹 Live search with debounce
  let debounceTimeout;
  searchInput.addEventListener('keyup', function () {
    clearTimeout(debounceTimeout);
    const query = this.value.trim();

    debounceTimeout = setTimeout(() => {
      if (!query) return showSuggestions();

      // show placeholder while fetching
      queriesContainer.classList.remove('active');
      placeholder?.style.setProperty('display', 'block');
      resultsContainer.style.display = 'none';

      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,article&resources[limit]=5`)
        .then(res => res.json())
        .then(data => {
          const { products = [], collections = [], articles = [] } = data.resources.results;
          let html = '';

          // Products
          products.forEach(p => {
            html += `
              <div class="product-list">
                <ul class="product-grid">
                  <li class="grid-item">
                    <a href="${p.url}">
                      <div class="product-grid-item">
                        ${p.featured_image?.url
                          ? `<img src="${p.featured_image.url}" alt="${p.title}">`
                          : svgPlaceholder
                        }
                        <span class="product-title">${p.title}</span>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>`;
          });

          // Collections
          collections.forEach(c => {
            html += `
              <div class="collection-list">
                <ul class="collection-grid">
                  <li class="collection-item">
                    <a href="${c.url}">
                      ${c.featured_image?.url
                        ? `<img src="${c.featured_image.url}" alt="${c.title}">`
                        : svgPlaceholder
                      }
                      <span class="collection-title">${c.title}</span>
                    </a>
                  </li>
                </ul>
              </div>`;
          });

          // Articles
          articles.forEach(a => {
            const formattedDate = new Date(a.published_at).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
            html += `
              <div class="article-list">
                <ul class="article-grid">
                  <li class="article-item">
                    <a href="${a.url}">
                      ${a.featured_image?.url
                        ? `<img src="${a.featured_image.url}" alt="${a.title}">`
                        : svgPlaceholder
                      }
                      <span class="article-title">${a.title}</span>
                    </a>
                  </li>
                </ul>
              </div>`;
          });

          showResults(html);
        })
        .catch(err => {
          
          showResults('');
        });
    }, 300);
  });

  // 🔹 Initialize drawer with suggestions active
  showSuggestions();
});
